// =============================================================================
// Terms of Service - Shared version constant
// =============================================================================
// Single source of truth for the current Terms of Service version.
// Both the API and frontend import from here to guarantee synchronization.
// Changing this value triggers re-acceptance for ALL users on next login.
// Format: YYYY-MM-DD matching the effective date of the ToS document.
// =============================================================================
export const CURRENT_TERMS_VERSION = '2026-02-26';
//# sourceMappingURL=terms.js.map